import { GenericErrorBanner } from 'hb-react/shared/components/GenericErrorBanner';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const PublicOfficeGenericErrorBanner = ({
  resetError = () => window.location.reload(),
}: {
  resetError?: () => void;
}) => (
  <ThemeProvider theme="po">
    <GenericErrorBanner resetError={resetError} />
  </ThemeProvider>
);

export default PublicOfficeGenericErrorBanner;
